export default "__VITE_ASSET__xbacpUri__"